module.exports = __webpack_public_path__ + "static/media/eco-ecology-firewood-svgrepo-com.99642ee5.svg";